import { Component, OnInit, ChangeDetectionStrategy, HostListener, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DataService } from '../../../@core/services/data.service';
import { CtaFormInterface, FormInput, FieldValue } from '../../../@core/models/site-material-data.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GoogleAnalyticsService } from '../../../@core/services/google-analytics.service';
import { AnalyticsService } from '../../../@core/services/analytics.service';
import * as Sentry from "@sentry/browser";
import { LeadifulService } from '../../../@core/services/leadiful.service';
import { SocialNetworksModel } from '../../../@core/models/social-networks.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FontsService } from 'src/app/@core/services/fonts.service';



@Component({
  selector: 'app-cta-form',
  templateUrl: './cta-form.component.html',
  styleUrls: ['./cta-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MaterialCtaFormComponent implements OnInit, OnDestroy {

  // ctaFormGroup: FormGroup;
  title: string;
  text: string;
  titleSize: string;
  textSize: string;
  textColor: string;
  fontWeight: string;
  titleFontFamily: string = '';
  titleFontFamilyName: string = '';
  titleColor: string;
  backgroundColor: string;
  textAlign: string;
  leadPosition: string;
  conversionLabel: string;
  consentText: string;
  buttonText: string = 'Get Started';
  forms: FormInput[] = [];
  errorMessage: string;
  data: CtaFormInterface;
  position: number = 0;
  positionField: number = undefined;
  test: string = '';
  formData: FieldValue[] = [];
  formValid: boolean = false;
  backgroundOption: boolean = false;
  privacyAgree: boolean = false;
  moduleInfo: string;
  imageBackground: string | string[];
  displayIcons: boolean = false;
  textUnderForm: string = '';
  linkTextUnderForm: string = '';
  leadTitle: string = '';
  sliderIndex: number = 0;
  style: string;
  innerWidth;
  activatePadding: boolean = false;
  socialNetworks: SocialNetworksModel = {};
  backgroundImages;
  privacyPolicyExist: boolean = false;
  privacyPolicyLink: string = '';
  timeOut;
  loading: boolean = false;
  loadingData$ = new BehaviorSubject<boolean>(false);
  successMsg$ = new BehaviorSubject<string>('');
  successMsg: string = '';
  minHeight: string = '';
  subscription: Subscription;
  allElementAnimation: string;
  textAnimation: string;
  formAnimation: string;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    if (this.imageBackground && this.innerWidth > 480) {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.sliderBackgroundImage();
      }, 5000);
    } else {
      this.style = `
      background-color: ${this.backgroundColor};
      background-image: ${this.backgroundColor.includes('#') ? 'none' : this.backgroundColor};`
    }
  }
  constructor(
    private dataService: DataService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private analyticsService: AnalyticsService,
    private leadifulService: LeadifulService,
    private _cdr: ChangeDetectorRef,
    private fontsService: FontsService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "MaterialCtaFormComponent");
    });
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.formAnimation = this.data.animation.form != '' ? this.data.animation.form : undefined;

    }
    this.loadingData$.next(true);
    // this.initForm();
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.title = this.data.title;
    this.text = this.data.text;
    this.consentText = this.data.consentText;
    this.conversionLabel = this.data.conversionLabel;
    this.buttonText = this.data.buttonText;
    this.fontWeight = this.data.fontWeight ? this.data.fontWeight : '';
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    this.leadPosition = this.data.leadPosition;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.textSize = this.data.textSize;
    this.innerWidth = window.innerWidth;
    this.textAlign = this.data.textAlign;
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.forms = this.data.inputs;
    this.imageBackground = this.data.imageBackground;
    this.displayIcons = this.data.displayIcons;
    this.textUnderForm = this.data.textUnderForm;
    this.linkTextUnderForm = this.data.linkTextUnderForm;
    this.minHeight = this.data.minHeight ? this.data.minHeight : "";
    this.backgroundOption = this.data.backgroundOption === false ? false : true;
    this.successMsg = this.data.successMsg ? this.data.successMsg : "Thanks for your interest. We'll get back to you soon!";
    this.leadTitle = this.data.leadTitle;
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.data.textColor;
    this.textColor = this.data.textColor ? this.data.textColor : this.dataService.getDefaultColor(this.backgroundColor);
    if (this.backgroundOption && this.imageBackground && this.imageBackground.length > 0 && this.innerWidth > 480) {
      this.sliderBackgroundImage();
    } else {
      if (this.imageBackground) this.sliderBackgroundImage();
      this.style = this.backgroundColor.includes('#') ? 'none' : this.backgroundColor;
    }
    this.subscription = this.dataService.getCurrentSite().subscribe(site => {
      this.privacyPolicyExist = site.privacyPolicy ? true : false;
      this.privacyPolicyLink = "https://" + (site.domainName ? site.domainName : site.siteUrl) + '/privacy-policy';
      if (site && this.displayIcons) {
        if (site && site.socialMedia) {
          site.socialMedia.forEach(element => {
            if (element.link) {
              this.socialNetworks[element.network] = element.link;
            }
          });
        }
      }
    });
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
    this.initFormData();
  }
  sliderBackgroundImage() {
    if (typeof this.imageBackground == 'string') {
      this.style = `url(${this.imageBackground})`;
    } else {
      this.imageBackground;
      if (this.imageBackground.length == this.sliderIndex + 1) {
        this.sliderIndex = -1
      }
      this.sliderIndex = this.sliderIndex + 1;
      if (this.imageBackground && this.innerWidth > 480) {
        this.style = `url(${this.imageBackground[this.sliderIndex]})`;
      }
      this._cdr.detectChanges();
      if (this.imageBackground.length > 1) {
        this.timeOut = setTimeout(() => {
          this.sliderBackgroundImage();
        }, 5000);
      }
    }
  }
  nextSliderClick(index: number) {
    this.sliderIndex = index;
    if (this.imageBackground && this.innerWidth > 480) {
      this.style = `url(${this.imageBackground[this.sliderIndex]})`;;
    }
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => {
      this.sliderBackgroundImage();
    }, 5000);
  }

  saveForm($event: FieldValue) {
    this.formData[$event.position] = $event;
    this.onSubmit();
  }

  agreePrivacyPolicy($event) {
    if ($event.target.checked) {
      this.privacyAgree = $event.target.checked;
    }
    this.onSubmit();
  }

  initFormData() {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.forms.length; i++) {
      this.formData.push({ required: this.forms[i].required, value: '', type: this.forms[i].type, position: i });
    }
  }

  onSubmit() {
    let formValid: boolean = true;
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.formData.length; i++) {
      if (this.formData[i].required && this.formData[i].value === '') {
        formValid = false;
      }
      if (this.formData[i].type === 'email') {
        // tslint:disable-next-line:max-line-length
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const email = regex.test(String(this.formData[i].value).toLowerCase());
        if (this.formData[i].value && !email) {
          formValid = false;
        }
      } else if (this.formData[i].type === 'phone') {
        if (this.formData[i].value && !String(this.formData[i]['value']).match(/^\d{10}$/g)) {
          formValid = false;
        }
      } else {
        const regex = new RegExp('^[a-zA-Z10-9 ,]+$');
        const text = regex.test(String(this.formData[i].value));
        if (this.formData[i].value && !text) {
          formValid = false;
        }
      }
    }
    if (formValid && this.privacyAgree) {
      this.formValid = true;
    } else {
      this.formValid = false;
    }
  }

  submitForm() {
    this.loading = true;
    let customFields = {};

    for (let i = 0; i < this.formData.length; i++) {
      if (this.forms[i].fieldId) {
        customFields[this.forms[i].fieldId] = this.formData[i].value;
      } else if (this.forms[i].name) {

        customFields[this.forms[i].name] = this.formData[i].value;
      } else {
        if (this.forms[i].type)
          customFields[this.forms[i].type] = this.formData[i].value;
      }
    }
    this.subscription = this.dataService.getSiteId().subscribe(siteId => {
      const currentSite = this.dataService.site$.getValue();
      this.dataService.postLeads({
        siteId,
        customFields
      }).subscribe(res => {
        this.loading = false;
        this.successMsg$.next(this.successMsg);
        if (currentSite) {
          this.analyticsService.trackConversion(currentSite, 'conversion');
        }
        if (currentSite.googleAnalyticsPixel) {
          this.googleAnalyticsService.eventEmitter('new_lead', 'new_lead', 'new_lead_' + siteId, 'leads');
        }
        if (currentSite.plugins) {
          const leadiful = currentSite.plugins.filter(plugin => plugin.name = "leadiful" && plugin.config['leadiful_key']);
          if (leadiful.length > 0) {
            customFields['site_form_source'] = currentSite.domainName && !currentSite.domainName.includes('undefined') ? currentSite.domainName : currentSite.siteUrl;
            this.leadifulService.postLead(leadiful[0].config['campaign_id'], leadiful[0].config['leadiful_key'], customFields).subscribe(data => {
            });
          }
        }
        if (currentSite.facebookPixel) {
          this.googleAnalyticsService.FbEventEmitter('Lead', 'lead', 'Lead ', 'new_lead');
        }
        if (currentSite.googleAdwordsPixel && this.conversionLabel) {
          this.googleAnalyticsService.AdsEventEmitter(`${currentSite.googleAdwordsPixel.conversionID}/${this.conversionLabel}`, 'new_lead', 'cta_form');
        }
        this._snackBar.open(this.successMsg, '', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['info-snackbar']
        });
      })
    });
  }

  setConsentChecked() {
    this.privacyAgree = !this.privacyAgree;
    this.onSubmit();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
